var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilledCustom = function SvgFilledCustom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.03 60.062 60.062",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.306 7.102c.083.168.204.315.353.429.151.114.327.193.513.23l5.862 1.187c.47.092.844.449.958.914.109.464-.067.948-.447 1.235l-4.562 3.463a1.204 1.204 0 0 0-.397.52c-.082.206-.104.43-.064.648l1.23 6.856c.083.467-.117.939-.51 1.204-.396.27-.911.293-1.33.059l-5.27-2.965a1.265 1.265 0 0 0-1.236 0l-5.271 2.965a1.261 1.261 0 0 1-1.33-.059 1.201 1.201 0 0 1-.51-1.204l1.23-6.855c.04-.218.018-.442-.063-.648a1.204 1.204 0 0 0-.398-.52L.502 11.098a1.201 1.201 0 0 1-.447-1.234c.114-.466.487-.823.957-.914l5.862-1.187c.186-.037.361-.116.512-.231.15-.114.271-.26.354-.43L10.907.696a1.253 1.253 0 0 1 2.234 0l3.165 6.407Z",
    fill: "#f7c104",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.001
  })));
};
export default SvgFilledCustom;